import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Dialog from './plugins/dialog'
import IndexedDB from './utils/indexedDB'
import store from './store'

Vue.config.productionTip = false
Vue.use(Dialog)
Vue.use(IndexedDB)

IndexedDB.init().then(() => {
  console.log('初始化成功')
  const app=new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')

})


